import api from "../../core/api";
import { Machine, PublicMachine } from "../models/machinesModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
}

class PublicMachinesApi {
  getMachine(number: string): Promise<Machine> {
    return api.get<Machine>(`/v1/public/machines/${number}`, getRequestConfig()).then(x => x.data);
  }

  getPublicMachine(id: string): Promise<PublicMachine> {
    return api.get<PublicMachine>(`/v1/public/machines/${id}/profile`, getRequestConfig()).then(x => x.data);
  }
}

export default new PublicMachinesApi();